import { InjectionToken, Injectable } from '@angular/core';

Injectable({ providedIn: 'root'});
export const componentMappingToken = new InjectionToken(
  'componentMappingToken'
);
